import React from 'react';

import { makeStyles } from '@material-ui/core/styles'
import Banner from "../components/banner/Banner"
import Login from "../components/login/Login"

import NoticeBanner from "../components/notice/NoticeBanner"
import ListNotice from '../components/notice/ListNotice';

const useStyles = makeStyles((theme) => ({
    container: {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "flex-start",

        "@media (min-width: 1334px)": {
            justifyContent: "center",

        },
    },

    LoginNotice: {
        "@media (max-width: 1000px)": {
            display: "none"
        }

    }
}))

const Notices = () => {

    const style = useStyles();

    return (
        <>
            <div className={style.container}>
                <div>
                    <Banner />
                    <ListNotice />
                </div>
                <div className={style.LoginNotice}>
                    <Login />
                    <NoticeBanner />
                </div>
            </div>
        </>
    );
};

export default Notices;